const redirectUri =
  process.env.REACT_APP_REDIRECT_URL ||
  'https://api-control.stage.sputnik.systems'

const baseConfig = {
  baseUri:
    process.env.REACT_APP_BASE_URL ||
    'https://api-control.stage.sputnik.systems/api/v1',
  redirectUri,
  socketUrl:
    process.env.REACT_APP_SOCKET_URL ||
    'wss://api-control.sputnik.systems/cable',
  ssoUri: process.env.REACT_APP_SSO_URL || 'https://sso.sputnik.systems',
  notifyUrl: 'https://notifier.sputnik.systems/api/v1/emails',
  intercomId: 'ControlUserWeb',
  brand: 'Спутник',
  app: 'Контроль',
  ssoPath: 'auth/sso',
  adminSlug: '',
  loginUri: redirectUri,
}

function setConfig() {
  let config = {}
  if (window.location.pathname.startsWith('/emergency_app')) {
    config = {
      baseUri: `${baseConfig.redirectUri}/api/emergency_app/v1`,
      redirectUri: `${baseConfig.redirectUri}/emergency_app`,
      socketUrl: `${baseConfig.socketUrl}/emergency_app`,
      loginUri: baseConfig.loginUri,
      ssoUri: baseConfig.ssoUri,
      notifyUrl: baseConfig.notifyUrl,
      intercomId: 'ControlUserWeb',
      brand: 'Спутник',
      app: 'Кабинет МЧС',
      ssoPath: 'auth/emergency_app',
      adminSlug: '/admin',
    }
  } else {
    config = baseConfig
  }

  return config
}

export default setConfig()
